// Lib imports
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment";

// Plugin imports
import "./plugins/vuetify";

// Application imports
import App from "./App";
import Components from "./components";
import router from "./router";
import store from "./store";

// Sync router with store
import { sync } from "vuex-router-sync";

// Sync store with router
sync(store, router);

// Use Moment for times
Vue.use(VueMoment, {
  moment
});

// Set Time defaults
moment.updateLocale("en", {
  longDateFormat: {
    LT: "h:mm A",
    LTS: "h:mm:ss A",
    L: "DD/MM/YYYY",
    LL: "Do MMMM YYYY",
    LLL: "Do MMMM YYYY LT",
    LLLL: "dddd, Do MMMM YYYY LT"
  }
});

// Load custom components
for (const key in Components) {
  Vue.component(key, Components[key]);
}

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  mounted() {
    this.$store.state.auth().onAuthStateChanged(user => {
      //console.log(user);
      let self = this;
      if (user) {
        this.$store.dispatch("setLoading", true);
        this.$store
          .dispatch("autoSignIn", user)
          .then(response => {
            console.log(response);
            // this.$store.getters.db.doc("setup/config")

            return this.$store.dispatch("loadConfig");
          })
          .then(() => {
            self.$store.dispatch("setLoading", false);
          })
          .catch(error => {
            console.log(error);
            self.$store.dispatch("setLoading", false);
          });
      } else {
        let token = null;
        let displayName = null;
        let email = null;

        this.createToken()
          .then(result => {
            this.$store.dispatch("setLoading", true);
            let resultObj = JSON.parse(result);
            token = resultObj.token;
            displayName = resultObj.displayName;
            email = resultObj.email;
            return this.$store.state.auth().signInWithCustomToken(token);
          })
          .then(function(user) {
            //console.log("token accepted");
            let newUser = user.user;
            if (!newUser.email || !newUser.displayName) {
              //console.log("email and displayname required", newUser);
              newUser
                .updateProfile({
                  displayName: displayName
                })
                .then(function() {
                  //console.log("displayName added", newUser);
                  let searchableIndex = Object.assign(
                    self.createIndex(displayName),
                    self.createIndex(newUser.uid)
                  );
                  let indexedItem = {
                    uid: newUser.uid,
                    name: displayName,
                    searchableIndex
                  };
                  return self.$store.state.db
                    .collection("students")
                    .doc(newUser.uid)
                    .set(indexedItem, { merge: true });
                })
                .then(function() {
                  //console.log("searchable indexes created");
                  return newUser.updateEmail(email);
                })
                .then(function() {
                  //console.log("email added", newUser);
                  return self.$store.dispatch("autoSignIn", newUser);
                })
                .then(function(response) {
                  //console.log(response);
                  self.$store.dispatch("setLoading", false);
                })
                .catch(function(error) {
                  //console.log(error);
                  self.$store.dispatch("setLoading", false);
                });
            }
          })
          .catch(function(error) {
            // look for token
            // Handle Errors here.
            console.error(error);

            // Look for token in $route.query
            let token = self.$route.query.token
              ? self.$route.query.token
              : "deakin access denied";
            self.$store.state
              .auth()
              .signInWithCustomToken(token)
              .then(function(user) {
                //Profile not created
                self.$store.dispatch("setLoading", false);
              })
              .catch(function(error) {
                console.error(error);
                self.$store.dispatch("setLoading", false);
              });
          });
      }
    });
  },
  methods: {
    createToken: function() {
      return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "deakin-login/login.php");
        // https://crowd-dev.deakin.edu.au/apps/health/opa-login/login.php
        xhr.onload = function() {
          if (this.status >= 200 && this.status < 300) {
            resolve(xhr.response);
          } else {
            reject(
              new Error({
                status: this.status,
                statusText: xhr.statusText
              })
            );
          }
        };
        xhr.onerror = function() {
          reject(
            new Error({
              status: this.status,
              statusText: xhr.statusText
            })
          );
        };
        xhr.send();
      });
    },
    createIndex: function(title) {
      const arr = title.toLowerCase().split("");
      const searchableIndex = {};
      let prevKey = "";
      for (const char of arr) {
        const key = prevKey + char;
        searchableIndex[key] = true;
        prevKey = key;
      }
      return searchableIndex;
    }
  },
  render: h => h(App)
}).$mount("#app");
